<template>
  <v-app :key="$ui.key">
    <slot></slot>

    <layout-toast></layout-toast>
    <layout-modal></layout-modal>
    <layout-modal-loading></layout-modal-loading>

    <component v-for="component in components" :is="component" :key="component"></component>
  </v-app>
</template>

<script>
import LayoutToast from '../Layout/LayoutToast'
import LayoutModal from '../Layout/LayoutModal'
import LayoutModalLoading from '../Layout/LayoutModalLoading'

export default {
  name: 'ALayout',
  components: { LayoutToast, LayoutModal, LayoutModalLoading },
  data () {
    return {
      isStripeLoaded: false,
      isAppLoading: true
    }
  },
  computed: {
    components () {
      return Object.keys(this.$ui.requiredComponents).map(name => {
        return name[0].toLowerCase() + name.slice(1, name.length).replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)
      })
    }
  },
  methods: {
    handleUiEvents () {
      this.$bus.on('ui/disconnected', () => {
        this.$router.push('/')
        this.$account.logout()
      })
    },
    includeClicky () {
      if (this.$ls.get('_ignore_clicky')) return
      window.clicky_site_ids = window.clicky_site_ids || []
      window.clicky_site_ids.push(101286529)
      let clicky = document.createElement('script')
      clicky.setAttribute('src', '//static.getclicky.com/js')
      clicky.addEventListener('load', (e) => {
        this.$bus.emit('ui/clicky/loaded', e)
        this.$services.clicky.flushEvents()
      }, false)
      document.head.appendChild(clicky)
    },
    async hideRecaptcha () {
      if (this.$ls.get('_ignore_recaptcha')) return
      await this.$recaptchaLoaded()
      const recaptcha = this.$recaptchaInstance
      recaptcha.hideBadge()
    }
  },
  async mounted () {
    this.handleUiEvents()
    this.includeClicky()
    this.hideRecaptcha()

    document.getElementById('html-preloader').style.display = 'none'
  }
}
</script>